import { NewProjectContainer } from "../../../container"

const NewProjectPage = () => {
  
    
  return <NewProjectContainer/>
}

export default NewProjectPage